import { ClipboardCheck, CloudLightning, Layers, Users, Wallet } from "lucide-react";

const BLOCKS = [
  {
    id: "storm",
    icon: CloudLightning,
    title: "Re-plan crews before a storm hits",
    text: "The operations map with real-time weather intelligence puts every property and crew on one screen, so you can reroute the moment conditions change.",
  },
  {
    id: "inspections",
    icon: ClipboardCheck,
    title: "Know every property is inspected, with records",
    text: "Assign inspections, capture photos, track issues and generate reports automatically. Every property carries a documented history.",
  },
  {
    id: "pay",
    icon: Wallet,
    title: "Pay crews without the spreadsheet",
    text: "Calculate and process crew payments from completed work. No manual tracking, no separate payment tool.",
  },
  {
    id: "vendors",
    icon: Users,
    title: "Your entire vendor network in one place",
    text: "Internal teams and outside vendors together, with role-based access, assignments and accountability on every job.",
  },
  {
    id: "platform",
    icon: Layers,
    title: "One platform for the whole operation",
    text: "Scheduling, properties, teams, inspections, issues, vendors and payments, connected end to end. Not five tools duct-taped together.",
  },
];

export const FeatureSection = () => (
  <section
    id="features"
    data-testid="features-section"
    className="scroll-mt-20 bg-royal-deep sidebar-grain px-4 py-16 sm:px-6 sm:py-20"
  >
    <div className="mx-auto max-w-6xl">
      <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold">What you actually do with it</p>
      <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-white sm:text-4xl">
        Built around the job, not the menu.
      </h2>

      <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {BLOCKS.map(({ id, icon: Icon, title, text }) => (
          <div
            key={id}
            data-testid={`feature-block-${id}`}
            className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition-colors duration-200 hover:border-gold/40"
          >
            <Icon className="h-6 w-6 text-gold" />
            <h3 className="mt-4 font-display text-base font-bold text-white md:text-lg">{title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-blue-100/75">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
